import { DeepKeys, DeepValue, FieldApi } from '@tanstack/react-form'

export default function getFormFieldLogicProps<FormValue, TKey extends DeepKeys<FormValue>>(
  field: FieldApi<FormValue, TKey>
) {
  return {
    name: field.name,
    value: field.state.value,
    isInvalid: field.state.meta.errors.length > 0,
    errorMessage: field.state.meta.errors[0],
    onValueChange: (value: DeepValue<FormValue, TKey>) => field.handleChange(value),
    onBlur: field.handleBlur,
  }
}
